/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * THIS FILE IS AN AUTOGENERATED TYPESCRIPT PROXY EXTENSION.
 * TO USE THIS FILE, IT MUST BE ADDED TO A D365COMMERCE APPLICATION
 */
// tslint:disable
import { AsyncResult, callActionOrExecute, DataServiceQuery, IContext, IDataServiceRequest } from '@msdyn365-commerce/retail-proxy';
// @ts-ignore
import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
import * as DataServiceEntities from './DataServiceEntities.g';

// @ts-ignore
function kRV_ATPQuery(id?: number): DataServiceQuery {
    const key = id ? { Id: id } : null;
    return new DataServiceQuery(
        'KRV_ATP',
        'KRV_ATPLeadTimePropertiesDate',
        DataServiceEntities.KRV_ATPLeadTimePropertiesDateExtensionClass,
        key
    );
}

export function createKRV_GetATPLeadTimeWithDateInput(itemId: string, requestedDate: string): IDataServiceRequest {
    const query = kRV_ATPQuery();
    return query.createDataServiceRequestForOperation(
        'KRV_GetATPLeadTimeWithDate',
        true,
        DataServiceEntities.KRV_ATPLeadTimePropertiesDateExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IKRV_ATPLeadTimePropertiesDate' },
        { itemId: itemId, requestedDate: requestedDate }
    );
}

export function kRV_GetATPLeadTimeWithDateAsync(
    context: IContext,
    itemId: string,
    requestedDate: string
): AsyncResult<DataServiceEntities.IKRV_ATPLeadTimePropertiesDate> {
    const request = createKRV_GetATPLeadTimeWithDateInput(itemId, requestedDate);
    return callActionOrExecute<DataServiceEntities.IKRV_ATPLeadTimePropertiesDate>(request, context.callerContext);
}

export function createKRV_GetATPLeadTimeWithQuantityInput(itemId: string, quantity: number): IDataServiceRequest {
    const query = kRV_ATPQuery();
    return query.createDataServiceRequestForOperation(
        'KRV_GetATPLeadTimeWithQuantity',
        true,
        DataServiceEntities.KRV_ATPLeadTimePropertiesQuantityExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IKRV_ATPLeadTimePropertiesQuantity' },
        { itemId: itemId, quantity: quantity }
    );
}

export function kRV_GetATPLeadTimeWithQuantityAsync(
    context: IContext,
    itemId: string,
    quantity: number
): AsyncResult<DataServiceEntities.IKRV_ATPLeadTimePropertiesQuantity> {
    const request = createKRV_GetATPLeadTimeWithQuantityInput(itemId, quantity);
    return callActionOrExecute<DataServiceEntities.IKRV_ATPLeadTimePropertiesQuantity>(request, context.callerContext);
}
